module.exports = __webpack_public_path__ + "img/6.23ea7788.png";